import { namedMols } from '@moleculeone/draw';
import { cloneDeep, isEqual } from 'lodash';

import { DEFAULT_MODE } from '../../etc/constants';
import { updateState } from '../state';

import {
  clipboardEffect,
  escapeEffect,
  historyEffect,
  modeEffect,
  modifyEffect,
  mouseEffect,
  removeEffect,
  updateHistory,
} from './molecule-object.effects';
import { cleanUpdate } from './reducer/cleanUpdate';
import * as interpreter from './reducer/interpreter';
import { mappedTraits } from './reducer/modes';
import { toggleKeys } from './reducer/toggleKeys';

const defaultState = {
  mols: [namedMols.exampleMols.empty, namedMols.exampleMols.empty, namedMols.exampleMols.empty],
  lastMolsUpdate: null,
  clipboard: namedMols.exampleMols.empty,
  selected: [[], [], []],
  mouse: {},
  mode: mappedTraits[DEFAULT_MODE].initial,
  history: {
    current: 0,
    list: [
      {
        mols: [namedMols.exampleMols.empty, namedMols.exampleMols.empty, namedMols.exampleMols.empty],
        selected: [[], [], []],
      },
    ],
  },
  error: null,
};

export default (state = defaultState, action) => {
  const currentMols = cloneDeep(state.mols);

  state = cleanUpdate(state, toggleKeys(state, action));
  const effect = interpreter.interpretKeys(state, action);
  if (effect == null) {
    return state;
  }

  state = cleanUpdate(state, mouseEffect(state, effect));
  state = cleanUpdate(state, modifyEffect(state, effect));
  state = cleanUpdate(state, removeEffect(state, effect));
  state = cleanUpdate(state, modeEffect(state, effect));
  state = cleanUpdate(state, clipboardEffect(state, effect, action));
  state = cleanUpdate(state, escapeEffect(state, effect));
  state = cleanUpdate(state, historyEffect(state, effect));
  state = cleanUpdate(state, mappedTraits[state.mode.type].effect(state, effect));
  state = updateState(state, updateHistory(state));

  const molsChanged = !isEqual(currentMols, state.mols);
  if (molsChanged) {
    state.lastMolsUpdate = new Date();
  }

  return state;
};
